import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './AuctionInspectionTime.scss';
import _sortBy from 'lodash/sortBy';
import _cloneDeep from 'lodash/cloneDeep';
import _filter from 'lodash/filter';
import Tooltip from '../Tooltip/Tooltip';
import TooltipText from '../../constants/TooltipText';
import AddToCalendarModal from '../Modal/AddToCalendarModal/AddToCalendarModal';
import AddToCalendarIcon from '../Icons/AddToCalendarIcon';

class AuctionInspectionTime extends Component {
  constructor(props) {
    super(props);
    this.showMoreThreshold = 1;
    this.dateFormat = 'ddd D MMM';
    this.timeFormat = 'h:mm a';
    this.state = {
      showMore: false,
      popover: false,
      inspectionData: [],
      hasVirtualInspection: false,
      inspectionTimeToAdd: { formatted: {date: '', start: '', end: '' } },
      showAddToCalendarModal: false
    };
    this.timeouts = {};
  }
  updateInspectionData = () => {
    let inspectionData = [];
    if (this.props.inspections) {
      this.props.inspections.map((inspection) => {
        let newInspection = {
          start: inspection.start,
          end: inspection.end,
          active: false,
          eventId: '',
          capacity: 0,
          status: '',
          virtual: false,
          formatted: {
            date: moment(inspection.start).format(this.dateFormat),
            start: moment(inspection.start).format(this.timeFormat),
            end: moment(inspection.end).format(this.timeFormat),
          }
        };
        inspectionData.push(newInspection);
      });
    }

    inspectionData = _sortBy(inspectionData, 'start');
    inspectionData = _filter(inspectionData, (item) => moment() < moment(item.end));
    this.setState({'inspectionData': inspectionData});
  }
  componentDidMount() {
    // mobile screen height variable for css
    if (window && window.innerHeight) {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
      window.addEventListener('resize', () => {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
      });
      window.addEventListener('orientationchange', () => {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
      });
    }
    this.updateInspectionData();
  }

  toggleShowMore = () => {
    this.setState({showMore: !this.state.showMore});
  }
  toggleAddToCalendar = (inspectionTime) => {
    this.setState({
      inspectionTimeToAdd: inspectionTime ? inspectionTime : { formatted: {date: '', start: '', end: '' } }
    });
    this.setState({ showAddToCalendarModal: !this.state.showAddToCalendarModal });
  }
  scrollToEnquiryForm = () => {
    this.props.handleCheckInspection();
    this.props.enquiryFormRef.current.scrollIntoView({behavior: 'smooth', block: 'start' });
  };

  render() {
    let mainList = _cloneDeep(this.state.inspectionData).splice(0, this.showMoreThreshold);
    let moreList = _cloneDeep(this.state.inspectionData).splice(this.showMoreThreshold, this.state.inspectionData.length - this.showMoreThreshold);

    return (
      <div className={'mt-2 w-100 ' + styles.auctionInspectionWrapper}>
        {this.props.auctionTime && (moment() < moment(this.props.auctionTime)) ?
          <div className={'d-flex pb-2 mb-2  ' + styles.auctionTime}>
            <span className={'bold600 ' + styles.auctionTimeTitle}>
              Auction Time
            </span>
            <div className={styles.timeColumn}>
              {moment(this.props.auctionTime).format(this.dateFormat + ' ' + this.timeFormat)}
            </div>

          </div>
          : null}

          <div>
            <div className={styles.inspectionTimesContainer}>
              <div className={'bold600 mb-2 ' + styles.inspectionDateTitle}>Inspection Times</div>
              <div className={styles.timeColumnWrapper}>
                <div className={styles.timeColumnContainer}>
                  <div className={styles.timeColumn}>
                    {mainList.map((item, index) => (
                      <div className={styles.inspectionTimeWrapper} key={index + 'inspectionTime'}>
                        <div className={styles.addToCalendarButton} title="Add to calendar" onClick={() => this.toggleAddToCalendar(item)}>
                          <AddToCalendarIcon />
                        </div>
                        <div className={styles.inspectionTime} key={index + 'inspectionTime'}>
                          <div className={'mr-2'}>{item.formatted.date}</div>
                          <div>{item.formatted.start} - {item.formatted.end}</div>
                        </div>
                      </div>
                    ))}
                    {this.state.showMore &&
                    moreList.map((item, index) => (
                      <div className={styles.inspectionTimeWrapper} key={index + 'inspectionTime'}>
                        <div className={styles.addToCalendarButton} title="Add to calendar" onClick={() => this.toggleAddToCalendar(item)}>
                          <AddToCalendarIcon />
                        </div>
                        <div className={styles.inspectionTime} key={index + 'inspectionTime'}>
                          <div>{item.formatted.date}</div>
                          <div>{item.formatted.start} - {item.formatted.end}</div>
                        </div>
                      </div>
                    ))}


                  </div>
                  {moreList.length > 0 ?
                    <div className={styles.showMoreLink} > <span onClick={this.toggleShowMore}>{this.state.showMore ? 'See Less' : `View ${moreList.length} more times`}</span></div>
                    : null}

                </div>
                {this.state.inspectionData.length > 0 ?
                  <div className={'mt-3'}>
                    Can't make any of these times?<br/><span className={styles.contactUsLink} onClick={this.scrollToEnquiryForm}>Contact agent</span> to arrange an inspection.
                  </div>
                  : null
                }
              </div>
            </div>
            {this.state.inspectionData.length === 0 ?
                <div>
                  No upcoming inspections scheduled.<br/><span className={styles.contactUsLink} onClick={this.scrollToEnquiryForm}>Contact agent</span> to arrange an inspection.
                </div>
                : null
            }
          </div>
        <AddToCalendarModal
          showModal={this.state.showAddToCalendarModal}
          closeModal={() => this.toggleAddToCalendar(null)}
          property={this.props.property.property}
          inspectionTime={this.state.inspectionTimeToAdd} />
      </div>
    );
  }
}

AuctionInspectionTime.propTypes = {
  inspections: PropTypes.array,
  auctionTime: PropTypes.string,
  enquiryFormRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  handleCheckInspection: PropTypes.func,
};

const mapStateToProps = (state) => (
  {
    property: state.propertyDetail,
    modalOpen: state.modals.open,
    user: state.user,
  }
);

export default connect(mapStateToProps, null)(AuctionInspectionTime);
